import ENV from "../config/env";
import healthCheckApi from "./healthCheck-api";

const key = ENV.HEALTH_MONITORING_API_KEY;
class HealthCheckService {
  getHealthMonitoringData = (days: number) => {
    const url = `/health-monitoring-data?days=${days}&key=${key}`;
    return healthCheckApi.post(url);
  };
}

export default new HealthCheckService();
